/**
 * Smoothly scrolls the page to the top.
 * Uses native browser smooth scrolling for optimal performance.
 */
export const smoothScrollToTop = (): void => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

/**
 * Smoothly scrolls the page to a specific element by its ID.
 * For best results, pass a non-sticky element to scroll to.
 */
export const smoothScrollToElement = (elementId: string): void => {
  const element = document.getElementById(elementId);
  if (element) {
    const elementRect = element.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    window.scrollTo({
      top: absoluteElementTop,
      behavior: 'smooth',
    });
  } else {
    // Fallback to top if element not found
    smoothScrollToTop();
  }
};
